import React from 'react';
import { Form, Formik } from 'formik';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { BoxWithTitle } from '../../../../components/common';
import { updateAttachedFiles, updateCompany } from '../../../../redux/actions/ReferralActions';
import { getCompany } from '../../../../redux/reducers/ReferralReducer';
import StepsFooter from '../steps/StepsFooter';
import { CommercialNameInput } from '../components/inputs/CommercialNameInput';
import { CompanyRFCInput } from '../components/inputs/CompanyRFCInput';
import { CityInput } from '../components/inputs/CityInput';
import { CompanyLegalNameInput } from '../components/inputs/CompanyLegalNameInput';
import { CountryInput } from '../components/inputs/CountryInput';
import { WebInput } from '../components/inputs/WebInput';
import { DropFileInput } from '../components/DropFileInput';
import { ClabeInput } from '../components/inputs/ClabeInput';
import { FullAddressInput } from '../components/inputs/FullAddressInput';
import { PostalCodeInput } from '../components/inputs/PostalCodeInput';
import { BankInput } from '../components/inputs/BankInput';
import { AccountInput } from '../components/inputs/AccountInput';
import { BankAccountCodeInput } from '../components/inputs/BankAccountCodeInput';
import { CompanyNITInput } from '../components/inputs/CompanyNITInput';
import { withRouter } from 'react-router-dom';
import { getValidationSchema } from '../../../../utils/Functions';

const OlaClickCompanyStep = ({ t, hasPrevious, handlePrevStep, handleNextStep, lastStep, activeStep, updateCompany, updateAttachedFiles, company, paramsForm, country }) => {
  const validationSchema = getValidationSchema(country, t).STEP_2;

  const handleSubmit = (values) => {
    updateAttachedFiles({
      proofOfTaxSituation: values.proofOfTaxSituation,
    });
    // eslint-disable-next-line no-param-reassign
    delete values.proofOfTaxSituation;
    updateCompany(values);
    handleNextStep();
  };

  const footerProps = {
    hasPrevious,
    handlePrevStep,
    lastStep,
    activeStep,
    t,
  };

  const initialValues = {
    commercialName: company.commercialName || '',
    legalName: company.legalName || '',
    rfc: company.rfc || '',
    clabe: company.clabe || '',
    fullAddress: company.fullAddress || '',
    city: company.city || '',
    zipCode: company.zipCode || '',
    country: company.country || '',
    web: company.web || '',
    bank: company.bank || '',
    account: company.account || '',
    accountCode: company.accountCode || '',
    accountType: company.accountType || '',
    proofOfTaxSituation: company.proofOfTaxSituation || '',
    nit: company.nit || '',
  };

  return (
    <Formik
      onSubmit={(values, actions) => {
        handleSubmit(values, actions);
      }}
      values
      validationSchema={validationSchema}
      validateOnChange
      initialValues={initialValues}
    >
      {({ errors, touched, values, isSubmitting }) => (
        <Form>
          <BoxWithTitle title={t('labelCompanyInformation')}>
            <div className="row">
              <div className="col-lg-6">
                <CommercialNameInput t={t} errors={errors} touched={touched} params={paramsForm} />
                <CompanyLegalNameInput t={t} errors={errors} touched={touched} params={paramsForm} />
                <CompanyRFCInput t={t} errors={errors} touched={touched} params={paramsForm} />
                {paramsForm.companyNITInput.show && <CompanyNITInput t={t} errors={errors} touched={touched} params={paramsForm} />}
                <CountryInput t={t} errors={errors} touched={touched} params={paramsForm} />
                {paramsForm.cityInput.show && <CityInput t={t} errors={errors} touched={touched} params={paramsForm} />}
              </div>
              <div className="col-lg-6">
                <FullAddressInput t={t} errors={errors} touched={touched} params={paramsForm} />
                {paramsForm.clabeInput.show && <ClabeInput t={t} errors={errors} touched={touched} params={paramsForm} />}
                {paramsForm.zipCodeInput.show && <PostalCodeInput t={t} errors={errors} touched={touched} params={paramsForm} />}
                <DropFileInput
                  name={paramsForm.dropFileInput.name}
                  label={t(paramsForm.dropFileInput.labelText)}
                  labelDropZoneOlaClick={t(paramsForm.dropFileInput.label)}
                  maxSizeOlaClick={paramsForm.dropFileInput.maxSize}
                  values={values}
                />
                <WebInput t={t} errors={errors} touched={touched} params={paramsForm} />
              </div>
            </div>
          </BoxWithTitle>
          {paramsForm.sectionInfoBank && (
            <BoxWithTitle title={t('labelBankInformation')}>
              {paramsForm.bankInput.show && <BankInput t={t} errors={errors} touched={touched} params={paramsForm} />}
              {paramsForm.accountInput.show && <AccountInput t={t} errors={errors} touched={touched} params={paramsForm} />}
              {paramsForm.bankAccountCodeInput.show && <BankAccountCodeInput t={t} errors={errors} touched={touched} params={paramsForm} />}
            </BoxWithTitle>
          )}
          <StepsFooter {...footerProps} isSubmitting={isSubmitting} />
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = (state) => {
  return {
    company: getCompany(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateCompany,
      updateAttachedFiles,
    },
    dispatch
  );
export default withRouter(compose(withNamespaces(), connect(mapStateToProps, mapDispatchToProps))(OlaClickCompanyStep));
